<template>
    <div class="sustainable-component admin-news">
        <!--<div class="bg-success mb-3 p-3 rounded">vue admin-news</div>-->
        <div class="container-fluid p-0 mt-3">
            <div class="row mb-3">
                <div class="col-12 p-0">
                    <CommonLabelContainer title="Skapa nyhet" class="mt-5 mb-3">
                        <v-form v-model="valid" ref="form">
                            <div class="container-fluid p-0">

                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <div class="container-fluid p-0">
                                            <div class="row">
                                                <div class="col">
                                                    <v-text-field bg-color="white"
                                                                  :rules="[rules.required]"
                                                                  name="Title"
                                                                  id="Title"
                                                                  type="text"
                                                                  label="Titel"
                                                                  variant="outlined"
                                                                  v-model="news.Title"
                                                                  focused="true"></v-text-field>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <CommonMCEEditor title="Innehåll" v-model:editorcontent="news.Content"></CommonMCEEditor>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-6 mt-3">
                                        <v-btn variant="tonal" @click="createNews" class="bg-primary">
                                            Skapa
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row table-space">
                <b>Visar {{newsItems.length}} Nyhetsinlägg</b>
                <table class="mt-2 table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                    <thead>
                        <tr>
                            <th class="col-3">Titel</th>
                            <th class="col-3">Innehåll</th>
                            <th class="col-2">Datum</th>
                            <th class="col-2">Visa</th>
                            <th class="col-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in newsItems" :key="index">
                            <td>{{item.Title}}</td>
                            <td><div v-html="item.Content"></div></td>
                            <td>{{item.Date}}</td>
                            <td>{{item.Show}}</td>

                            <td valign="middle">
                                <div class="pull-right" style="">
                                    <div class="dropdown text-right pr-2">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item" @click="updateNews(item)">Ändra</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="deleteNews(item.NewsId)">Ta bort</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
        <UpdateNews ref="updateNewsModal" @updated="loadNews"></UpdateNews>
    </div>
</template>


<script>

    import ValidationService from "../../Services/ValidationService";
    import AdminService from "../../Services/AdminService";
    import CommonLabelContainer from "../../common/common-label-container";
    import UpdateNews from './update/update-news.vue'
    import CommonSpinner from '../../common/common-spinner.vue'
    import CommonMCEEditor from '../../common/common-mce-editor.vue'
    import { ref } from 'vue'
    const form = ref(null);
    const updateNewsModal = ref(null);

    export default {

        name: 'admin-news',
        props: {
            departmentid: String,
        },
        components: {
            UpdateNews,
            CommonLabelContainer,
            CommonSpinner,
            CommonMCEEditor
        },
        methods: {
            async createNews() {
                var result = await this.form.validate()
                if (result.valid != true)
                    return;
                this.loading++;
                try {
                    await AdminService.createNews(this.news);
                    this.displaySnackBar("Nyheten lades till");
                    this.loadNews();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async loadNews() {
                this.loading++;
                try {
                    this.newsItems = await AdminService.getNews();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async updateNews(news) {
                this.loading++;
                this.updateNewsModal.open(news)
                this.loading--;
            },
            async deleteNews(newsId) {
                if (confirm("Är du säker att du vill radera nyhetsinlägget?"))
                {
                    this.loading++;
                    try {
                        await AdminService.deleteNews(newsId);
                        this.displaySnackBar("Nyheten togs bort");
                        this.loadNews();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                rules: ValidationService.rules(),
                news: {
                    Title: '',
                    Content: '',
                },
                newsItems: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {

        },
        mounted() {
            this.loadNews();
        },
        setup() {
            return { form, updateNewsModal }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>